import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { AutoSelectionLanding } from './types';

export function useAutoSelectionLandingData(): Page<AutoSelectionLanding>['templateFields'] {
  return useCurrentPage<Page<AutoSelectionLanding>>().templateFields;
}
